export default {
  default: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/layouts/default.vue").then(m => m.default || m)
}